/**
 * Created by Carsten Bühler
 * User: CBuehler on 22.10.2015
 * Copyright: xdot GmbH 2015
 */
import keyMirror from 'external/keymirror';

export default keyMirror({

    REQUESTED: null,
    SUCCESS: null,
    ERROR: null

});




// WEBPACK FOOTER //
// ./js/constants/AsyncState.js